import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { text } from "@quickpoint.me/shared";

const landmarks: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11ySemanticHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11ySemanticBody}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "a[href='#main-editor']",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11ySkipHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11ySkipLink}
						<br />
						<br />
						{text.tourSteps.a11yTryTab}
					</span>
				)}
			/>
		),
	},
];

export default landmarks;
